// Validating the DEL class and subclasses before being sent to the backend.

// Validating the draft del project.
export const validateDraftDelProject = (projectData, delMode) => {
  const errors = {};
  console.log("delMode for validation", delMode);

  // If delMode is in "new" mode, we will check if the noProjectNumberChecked is true, if so we will only need to validate the projectDescription and invoiceManager.
  if (delMode === "new") {
    if (projectData.noProjectNumberChecked) {
      if (
        !projectData.projectDescription ||
        projectData.projectDescription.trim() === ""
      ) {
        errors.projectDescription = "Project Description is required";
      }
      // If the noProjectNumberChecked is false, then we need to validate the  projectNumber, any phases, tasks that may be available have been selected, and invoice manager is selected.
    } else {
      if (
        !projectData.projectNumber ||
        projectData.projectNumber.trim() === ""
      ) {
        errors.projectNumber = "Project Number is required";
      }
      if (!projectData.phaseId || projectData.phaseId.trim() === "") {
        errors.phaseId = "Phase is required";
      }
      // If there are tasks available in the availableTasks array, then we need to make sure that a task is selected.
      if (projectData.availableTasks.length > 0) {
        if (!projectData.taskId || projectData.taskId.trim() === "") {
          errors.taskId = "Task is required";
        }
      }
      // Validating the project manager, but only if the projectData.noProjectNumberChecked is false.
      if (!projectData.noProjectNumberChecked) {
        if (
          !projectData.projectManager.id ||
          projectData.projectManager.id.trim() === ""
        ) {
          errors.projectManager = "Project Manager is required";
        }
      }
    }
  }
  // If the delMode is in edit mode, and the Project Description is empty or the project number is empty, then we need to return an error.
  if (delMode === "edit") {
    // If the Project Description is empty, we need to make sure that project number and phase are not empty.
    if (
      !projectData.projectDescription ||
      projectData.projectDescription.trim() === ""
    ) {
      if (
        !projectData.projectNumber ||
        projectData.projectNumber.trim() === ""
      ) {
        errors.projectNumber = "Project Number is required";
      }
      if (!projectData.phaseId || projectData.phaseId.trim() === "") {
        errors.phaseId = "Phase is required";
      }
      if (projectData.availableTasks.length > 0) {
        if (!projectData.taskId || projectData.taskId.trim() === "") {
          errors.taskId = "Task is required";
        }
      }
    } else {
      if (projectData.projectDescription) {
        if (projectData.projectDescription.trim() === "") {
          errors.projectDescription = "Project Description is required";
        }
        if (
          projectData.projectNumber &&
          projectData.projectNumber.trim() !== ""
        ) {
          if (!projectData.phaseId || projectData.phaseId.trim() === "") {
            errors.phaseId = "Phase is required";
          }
          if (projectData.availableTasks.length > 0) {
            if (!projectData.taskId || projectData.taskId.trim() === "") {
              errors.taskId = "Task is required";
            }
          }
        }
      }
    }
  }
  // Validating the invoice manager, This will always be required.
  if (
    !projectData.invoiceManager.id ||
    projectData.invoiceManager.id.trim() === ""
  ) {
    errors.invoiceManager = "Invoice Manager is required";
  }
  // The date of the DEL is not required for draft validation.

  return errors;
};

export const validateSubmittedDelProject = (projectData, delMode) => {
  // Start with validating the draft del project. We will add to this if needed.
  const errors = validateDraftDelProject(projectData, delMode);

  // Validating date of DEL.
  if (!projectData.date || projectData.date.trim() === "") {
    errors.date = "Date of DEL is required";
  }

  return errors;
};

// Validating the DEL project for approval - stricter than submit
// Requires project_number AND phase_id (not just description)
export const validateApprovedDelProject = (projectData) => {
  const errors = {};

  // Project Number is REQUIRED for approval (not just description)
  if (!projectData.projectNumber || projectData.projectNumber.trim() === "") {
    errors.projectNumber = "Project Number is required for approval";
  }

  // Phase is REQUIRED for approval
  if (!projectData.phaseId || projectData.phaseId.trim() === "") {
    errors.phaseId = "Phase is required for approval";
  }

  // If there are tasks available, task is required
  if (projectData.availableTasks && projectData.availableTasks.length > 0) {
    if (!projectData.taskId || projectData.taskId.trim() === "") {
      errors.taskId = "Task is required for approval";
    }
  }

  // Project Manager is required for approval
  if (
    !projectData.projectManager?.id ||
    projectData.projectManager.id.trim() === ""
  ) {
    errors.projectManager = "Project Manager is required for approval";
  }

  // Invoice Manager is always required
  if (
    !projectData.invoiceManager?.id ||
    projectData.invoiceManager.id.trim() === ""
  ) {
    errors.invoiceManager = "Invoice Manager is required";
  }

  // Date of DEL is required
  if (!projectData.date || projectData.date.trim() === "") {
    errors.date = "Date of DEL is required";
  }

  return errors;
};
